var React = require('react');

function LandingPageHeroBlobBottomInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M390 24.4C237.4 19.4 162.6 4.5 0 .8V32h390v-7.6z","fill":"currentColor"}));
}

LandingPageHeroBlobBottomInline.defaultProps = {"width":"390","height":"32","viewBox":"0 0 390 32"};

module.exports = LandingPageHeroBlobBottomInline;

LandingPageHeroBlobBottomInline.default = LandingPageHeroBlobBottomInline;
